import classNames from 'classnames';
import styles from './Macro.module.scss';
import Skeleton from 'react-loading-skeleton';

const Loading = () => {
    return (
        <>
            {Array(6)
                .fill(1)
                .map((_record, _recordIndex: number) => (
                    <div
                        className="col-sm-6 col-md-4"
                        key={`macro-${_recordIndex}`}
                    >
                        <div
                            className={classNames(
                                styles.chooser_inner,
                                styles.with_sub,
                            )}
                        >
                            <h5>
                                <Skeleton height="29px" width="137px" />
                            </h5>
                        </div>
                    </div>
                ))}
        </>
    );
};

export default Loading;
